import { OidcSecurityService } from "angular-auth-oidc-client";
import { Component, HostListener, OnInit } from "@angular/core";
import { Observable, of, Subscription } from "rxjs";
import { environment } from "environments/environment";
import { NavbarService } from "./services/shared/navbar.service";
import { AuthService } from "./services/auth/auth.service";
import { PermissionsService } from "./services/permissions/permissions.service";
import { MemberService } from "./services/member.service";
import { ClaimsService } from "./services/claims/claims.service";
import { CountryService } from "./services/shared/country.service";
import { ActivatedRoute, Router } from "@angular/router";
import { CampaignService } from "./services/campaigns/campaign.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit {
  title = "";
  userData$: Observable<any> = of({});

  isAuthenticated = false;
  cornerribbontext;
  cornerribboncolor;
  helpopened = false;
  claims: any;
  loggedin: boolean = false;
  userid;
  countriesSubscription: Subscription;
  constructor(
    private oidcSecurityService: OidcSecurityService,
    private countryService: CountryService,
    private claimsService: ClaimsService,
    private memberService: MemberService,
    private navbarService: NavbarService,
    private authService: AuthService,
    private permissionsService: PermissionsService,
    private campaignService: CampaignService,
    private router: Router,
    private route: ActivatedRoute
  ) {

    this.navbarService.helpopened$.subscribe((x) => {
      this.helpopened = x;
    });
  }

  ngOnInit(): void {
    if (window.location.pathname == '/resetpassword2') {
      const url = new URL(window.location.href);
      const userId = url.searchParams.get('userId');
      const token = url.searchParams.get('token');
      this.router.navigate(['resetpassword2'], {
        queryParams: {
          userId: userId,
          token: token
        }
      });
    } else if (window.location.pathname == '/resetpassword') {
      this.router.navigateByUrl('resetpassword');
    } else if (window.location.pathname == '/lockedout') {
      this.router.navigateByUrl('lockedout');
    } else {
      this.oidcSecurityService.checkAuth().subscribe(({ isAuthenticated }) => {
        this.isAuthenticated = isAuthenticated;
        if (!this.isAuthenticated) {
          this.login();
        } else {
          this.userData$ = this.oidcSecurityService.userData$;
          this.authService.enhancedUserData$.subscribe((data) => {
            if (data) {
              this.claims = data.claims;

              this.claimsService.setClaims(this.claims);
              this.authService.claims.next(this.claims);
              this.loggedin = true;

              this.oidcSecurityService.getAccessToken().subscribe((token) => {
                this.authService.accesstoken.next(token);

                this.permissionsService.userid = this.claims.find((c) => c.type === "name")?.value;
                this.userid = this.permissionsService.userid;
                sessionStorage.setItem('userid', JSON.stringify(this.userid));
              
                this.permissionsService.getUserPermissionAsync().subscribe((permissions) => {
               
                  const selectedrole = JSON.parse(sessionStorage.getItem('selectedrole'));

                  if (JSON.parse(localStorage.getItem('countries'))?.length > 0) {
                    this.countryService.setCountryList(JSON.parse(localStorage.getItem('countries')));
                  } else {
                    this.countryService.getCountries().subscribe(data => {
                      this.countryService.setCountryList(data);
                    });
                  }
 this.permissionsService.getActiveRole().subscribe(resp => {

      if (resp != -1) {
      // sessionStorage.setItem('selectedrole', resp);
      
        this.permissionsService.changeActiveRole(resp, 999).subscribe((x) => {
          if(x) {
          if (selectedrole !== null) {
                    //const selectedroleid = JSON.parse(sessionStorage.getItem('selectedrole')).roleId;
                    const selectedroleid = JSON.parse(sessionStorage.getItem('selectedrole')).roleId;
                    const selectedindex = Number(localStorage.getItem('selectedindex'));
                   
                    this.permissionsService.changeActiveRole(selectedroleid, selectedindex).subscribe((x) => { });
                  }}
         });
        
      }
    });




/*this.campaignService.getCampaigns().subscribe((campaigns) => {
  console.log('campaigns: ', campaigns);
});*/



                /*test  if (selectedrole !== null) {
                    const selectedroleid = JSON.parse(sessionStorage.getItem('selectedrole')).roleId;
                    const selectedindex = Number(localStorage.getItem('selectedindex'));
                    console.log('selectedroleid: ', selectedroleid);
                    this.permissionsService.changeActiveRole(selectedroleid, selectedindex).subscribe((x) => { });
                  }*/
                  this.permissionsService.userpermissions.next(permissions);

                  if (window.navigator.userAgent.toLowerCase().includes("mobi")) {
                    this.permissionsService.roleidx = 4;
                  }

                  this.permissionsService.setSelectedRole(
                    Number(localStorage.getItem("selectedindex"))
                  );

                  this.permissionsService.selectedindex.next(
                    Number(localStorage.getItem("selectedindex"))
                  );
                  
                });
              });

              // Kontrollera om det är en mobilenhet
              this.authService.isMobileDevice.next(
                window.navigator.userAgent.toLowerCase().includes("mobi")
              );

              this.memberService.getOwnBaseInfoAsync().subscribe((data) => {
                this.claimsService.claims$.next(data);
                this.memberService.setBaseInfo(JSON.stringify(data));
              });
            }
          });
        }
      });
    }
    this.cornerribbontext = environment.cornerRibbonText;
    this.cornerribboncolor = environment.cornerRibbonColor;
  }
  login(): void {
    this.oidcSecurityService.authorize();
  }

  refreshSession(): void {
   
    this.oidcSecurityService.authorize();
  }

  logoffAndRevokeTokens(): void {
    this.oidcSecurityService
      .logoffAndRevokeTokens()
      .subscribe((result) => console.log(result));
  }

  revokeRefreshToken(): void {
    this.oidcSecurityService
      .revokeRefreshToken()
      .subscribe((result) => console.log(result));
  }

  revokeAccessToken(): void {
    this.oidcSecurityService
      .revokeAccessToken()
      .subscribe((result) => console.log(result));
  }

  @HostListener("window:beforeunload")
  onBeforeUnload() {
    localStorage.setItem(
      "selectedindex",
      JSON.stringify(this.permissionsService.selectedindex.getValue())
    );
    sessionStorage.setItem(
      "selectedrole",
      JSON.stringify(this.permissionsService.selectedrole.getValue())
    );
    localStorage.setItem(
      "claims",
      JSON.stringify(this.claimsService.claims$.getValue())
    );
    localStorage.setItem(
      "countries",
      JSON.stringify(this.countryService.getCountryList())
    );
  }

  ngOnDestroy() {
    // this.isloggedinSubscription.unsubscribe();
    // this.permissionsSubscription.unsubscribe();
    this.countriesSubscription.unsubscribe();
  }
}
